import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/(protected)/admin/(content)/aspen-services": [7],
		"/(protected)/admin/(content)/emergency-broadcast": [8],
		"/admin/feedbacks/[id]": [13],
		"/(protected)/admin/(content)/ml-scanner": [9],
		"/ai-workflow": [14],
		"/(protected)/alerts-concept": [10],
		"/alerts": [15],
		"/alerts/[id]": [16,[],[2]],
		"/analytics/energy-forecast": [17],
		"/approved-alerts": [18],
		"/approved-alerts/[id]": [19,[],[3]],
		"/dashboard": [20],
		"/dashboard/admin": [21],
		"/(protected)/dashboard/admin/data-explorer": [11],
		"/(protected)/dashboard/admin/technician-map": [12],
		"/feedback": [22],
		"/field-tech": [23,[4]],
		"/field-tech/alerts": [24,[4]],
		"/field-tech/profile": [25,[4]],
		"/field-tech/schedule": [26,[4]],
		"/field-tech/session/[id]": [27,[4]],
		"/field-tech/tracking": [28,[4]],
		"/field-tech/work-orders": [29,[4]],
		"/field-tech/work-orders/[id]": [30,[4]],
		"/login": [31],
		"/logs": [32],
		"/ml-predictions": [33],
		"/my-feedback": [34],
		"/my-feedback/[id]": [35],
		"/password-reset": [36],
		"/profile": [37],
		"/reset-password": [~38],
		"/work-orders": [39],
		"/work-orders/[id]": [40,[],[5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';